import GooglePlayButton from 'assets/google-play-button.svg?react';
import qs from 'qs';

const GoogleStoreButton = () => (
  <a
    href={`https://play.google.com/store/apps/details?${qs.stringify({
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
      id: import.meta.env.VITE_APP_BUNDLE_IDENTIFIER,
      referrer: window.location.href,
    })}`}
  >
    <GooglePlayButton />
  </a>
);

export default GoogleStoreButton;
